import React from 'react';
import { Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { Controller, FieldValues } from 'react-hook-form';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';

import { ICustomTextProps } from 'models/Form';
import './FormComponents.css';

export function ControlledDatePickerInput<T extends FieldValues>({
  fieldName,
  control,
  label,
  placeholder,
  rules,
  readonly,
  minDate,
}: ICustomTextProps<T>) {
  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules || {}}
      render={({ field, fieldState, formState }) => {
        if (readonly && !field.value) {
          return <Input readOnly value="" />;
        }

        var className: string = 'form-control';
        if (!fieldState.invalid && (fieldState.isTouched || formState.isSubmitted)) {
          className = 'datepicker is-valid form-control';
        } else if (fieldState.invalid && (fieldState.isTouched || formState.isSubmitted)) {
          className = 'datepicker is-invalid form-control';
        }
        return (
          <>
            <span>{label}</span>
            <DatePicker
              minDate={minDate || dayjs(new Date()).add(7, 'd').toDate()}
              readOnly={readonly}
              showWeekNumbers={true}
              shouldCloseOnSelect={true}
              id={fieldName}
              className={className}
              value={field.value ? dayjs(new Date(field.value as string)).format('YYYY-MM-DD') : ''}
              selected={field.value ? new Date(field.value as string) : null}
              onChange={(date, event) => {
                event?.preventDefault();
                field.onChange(date !== null ? date : '');
              }}
              placeholderText={placeholder || ''}
              disabled={readonly}
            />
          </>
        );
      }}
    />
  );
}
